
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';
import { TemplatesComponent } from './templates.component';

@Component({
  selector: 'app-templates-page',
  templateUrl: './templates.page.html',
  styleUrls: ['./templates.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
    TemplatesComponent,
  ],
})
export class TemplatesPage {

}
